import styles from './schemeEditor.module.css';
import { forwardRef, useEffect, useImperativeHandle, useMemo, useState } from 'react';
import SchemeNode from './SchemeNode';
import { SchemeEditorProvider, useSchemeEditorContext } from './SchemeEditorProvider';
import InsertSchemeNodeButton from './SchemeButtons/InsertSchemeNodeButton';
import { SchemeModes } from '../../consts/scheme.consts';
import classnames from 'classnames';
import Spinner from 'ui/Spiner';
import { devicesStore } from 'store/mobx/devices.store';

const SchemeEditor = forwardRef(({ ...rest }, ref) => {
  return (
    <SchemeEditorProvider {...rest}>
      <SchemeEditorComponent ref={ref} />
    </SchemeEditorProvider>
  );
});

const TrackedSchemeNode = ({
  item,
  index,
  onMount,
  useStatusIndication,
  loadingDeviceType = 'model',
}) => {
  useEffect(() => {
    onMount();
  }, [onMount]);

  return (
    <SchemeNode
      item={item}
      index={index}
      useStatusIndication={useStatusIndication}
      loadingDeviceType={loadingDeviceType}
    />
  );
};

const SchemeEditorComponent = forwardRef((_, ref) => {
  const { nodes, schemeMode, useStatusIndication, loadingDeviceType } = useSchemeEditorContext();
  const { setDevicesModels } = devicesStore;

  useImperativeHandle(ref, () => ({}));

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    loadDevicesModels();
  }, []);

  const loadDevicesModels = async () => {
    await setDevicesModels();
  };

  const nodesMemo = useMemo(() => {
    setIsLoading(false);

    if (nodes && nodes.length === 0) {
      setIsLoading(true);
      return null;
    }

    return nodes?.map((item, index) => {
      return (
        <TrackedSchemeNode
          key={index}
          item={item}
          index={index}
          loadingDeviceType={loadingDeviceType}
          useStatusIndication={useStatusIndication}
          onMount={() => {
            setIsLoading(true);
          }}
        />
      );
    });
  }, [nodes, setIsLoading, useStatusIndication]);

  const NoDataTemplate = () => <div className={styles.noData}>На схему ничего не добавлено.</div>;

  return (
    <>
      {!isLoading && <Spinner text="Загрузка схемы" />}
      <div className={classnames(styles.container, { [styles.isLoading]: isLoading })}>
        <div className={styles.nodes}>{nodesMemo}</div>
        {schemeMode === SchemeModes.edit && !nodesMemo?.length && <InsertSchemeNodeButton />}
        {schemeMode === SchemeModes.view && !nodesMemo?.length && <NoDataTemplate />}
      </div>
    </>
  );
});

SchemeEditorComponent.displayName = 'SchemeEditorComponent';
SchemeEditor.displayName = 'SchemeEditor';

export default SchemeEditor;
